export default {"src":"/_next/static/media/group-users-icon.f43629b6.svg","height":16,"width":16};